import React from 'react';
import {ConfigurationApplication} from '@application/Config';
import {TradeName} from '@domain/model/Config/Configuration';
import {LogoImage} from './LogoImage';

interface LogoProps {
  light?: boolean;
}

const LOGO_WIDTH: Record<TradeName, number> = {
  [TradeName.LOOKIERO]: 102,
  [TradeName.OUTFITTERY]: 138,
};

export const Logo: React.FC<LogoProps> = ({light}) => {
  const tradeName = ConfigurationApplication.retrieve().tradename;
  return <LogoImage width={LOGO_WIDTH[tradeName]} light={light} />;
};
